import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="datagrids--table"
// You can listen to `datagrids--table:selection-changed` event to get a list of selected rows (ids) and its changes
export default class extends Controller {
  connect() {
    this.selectedRows = []
    this._initCheckboxes()
  }

  selectedRowsAsHiddenFieldIds() {
    let fields = []
    this.selectedRows.forEach((id) => {
      let field = document.createElement('input')
      field.setAttribute('type', 'hidden')
      field.setAttribute('name', 'ids[]')
      field.setAttribute('value', id)
      fields.push(field)
    })
    return fields
  }

  _initCheckboxes() {
    this.selectedRows = []

    this.mainCheckbox = this.element.querySelector('thead input[type="checkbox"][name="row_selector"]')
    if (this.mainCheckbox) {
      this.mainCheckbox.addEventListener("change", this._toggleAllCheckboxes.bind(this))
    }

    this.rowCheckboxes = this.element.querySelectorAll('tbody input[type="checkbox"][name="row_selector"]')
    if (this.rowCheckboxes.length > 0) {
      this.rowCheckboxes.forEach((checkbox) => checkbox.addEventListener("change", this._toggleCheckbox.bind(this)))
    }
  }

  _toggleAllCheckboxes(e) {
    this.selectedRows = []
    this.element.querySelectorAll('tbody input[type="checkbox"][name="row_selector"]').forEach((checkbox) => {
      checkbox.indeterminate = false
      checkbox.checked = e.target.checked
      if (e.target.checked) this.selectedRows.push(checkbox.value)
    })

    this.dispatch('selection-changed', {detail: {selectedRows: this.selectedRows}})
  }

  _toggleCheckbox(e) {
    let totalItems = this.rowCheckboxes.length
    let checkedItems = this.element.querySelectorAll('tbody input[type="checkbox"][name="row_selector"]:checked').length

    if (e.target.checked) {
      this.selectedRows.push(e.target.value)
    } else {
      this.selectedRows = this.selectedRows.filter((value) => value !== e.target.value)
    }

    if (totalItems === checkedItems) {
      this.mainCheckbox.indeterminate = false
      this.mainCheckbox.checked = true
    } else if (checkedItems > 0 && checkedItems < totalItems) {
      this.mainCheckbox.indeterminate = true
    } else {
      this.mainCheckbox.indeterminate = false
      this.mainCheckbox.checked = false
    }

    this.dispatch('selection-changed', {detail: {selectedRows: this.selectedRows}})
  }
}
